import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Form, Field } from '@smartplatform/ui';
import store from '../../../store';

@observer
export class AddressEdit extends React.Component {
	@observable record = null;
	@observable error = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.id = this.props.match.params.id;
		this.error = null;
		if (this.id) {
			try {
				this.record = await store.model.Address.findById(this.id);
			} catch (e) {
				this.error = e.message;
			}
		} else {
			this.record = new store.model.Address();
		}
	};

	render() {
		if (!this.record && !this.error) return '...';
		if (this.error) return this.error;

		return (
			<>
				<Form record={this.record} rootPath="/admin" returnTo="/admin/divisions/addresses">
					<Field property="street" label="Название" disabled />
					<Field property="building" label="Название" disabled />
					<Field relation="city" property="name" label="Город" disabled />
					<Field relation="division" property="name" label="Избирательный округ" />
				</Form>
			</>
		);
	}
}
